import {
  IStateMetaData,
  IMachineContext,
  TMachineActions,
  TInputTypes,
  TCoinTossEvents,
  TCoinTossStates,
  TMachineStates,
  TMachineEvents,
} from '@/types';
import type { AnyEventObject, BaseActionObject, StateNodeConfig } from 'xstate';
import { MAIN_MACHINE_ID } from '@/constants';
import {
  onCoinTossWinnerSelected,
  onKickOrReceiveSelected,
  onOffenseOrDefenseSelected,
  onSideSelected,
} from './nextActions/coinToss';

export const COIN_TOSS_MACHINE: StateNodeConfig<IMachineContext, any, AnyEventObject, BaseActionObject> = {
  initial: TCoinTossStates.SELECT_WINNER,
  states: {
    [TCoinTossStates.SELECT_WINNER]: {
      meta: {
        component: TInputTypes.TWO_ROW_GENERIC,
        componentConfiguration: {
          title: 'Coin Toss Winner',
          showLogo: false,
          showBackBtn: true,
        },
        onNext: onCoinTossWinnerSelected,
        onBack({ send, generalState }) {
          generalState.clearCurrentGame();
          send(TCoinTossEvents.BACK, {
            ctxUpdate: {
              currentWorkflow: null,
            },
          });
        },
      } as IStateMetaData,
      on: {
        [TCoinTossEvents.ON_SELECTED_WINNER]: {
          target: TCoinTossStates.SELECT_KICK_OR_RECEIVE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.BACK]: {
          target: `#${MAIN_MACHINE_ID}.${TMachineStates.GAME_SELECTION}`,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.UNSET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.TO_OFFENCE_DEFENCE]: {
          target: TCoinTossStates.SELECT_OFFENCE_DEFENCE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
      },
    },

    [TCoinTossStates.SELECT_KICK_OR_RECEIVE]: {
      meta: {
        component: TInputTypes.TWO_ROW_GENERIC,
        componentConfiguration: {
          title: 'Kick or Receive',
          showLogo: false,
          showBackBtn: true,
        },
        onNext: onKickOrReceiveSelected,
        onBack({ send, playFlowState }) {
          playFlowState.setActiveTeam(null);

          send(TCoinTossEvents.BACK);
        },
      } as IStateMetaData,
      on: {
        [TCoinTossEvents.TO_SELECT_SIDE]: {
          target: TCoinTossStates.SELECT_SIDE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.BACK]: {
          target: TCoinTossStates.SELECT_WINNER,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.UNSET_NEXT_STATE_INPUT],
        },
      },
    },

    [TCoinTossStates.SELECT_OFFENCE_DEFENCE]: {
      meta: {
        component: TInputTypes.TWO_ROW_GENERIC,
        componentConfiguration: {
          title: 'Offense or Defense',
          showLogo: false,
          showBackBtn: true,
        },
        onNext: onOffenseOrDefenseSelected,
        onBack({ send, playFlowState }) {
          playFlowState.setActiveTeam(null);
          send(TCoinTossEvents.BACK);
        },
      } as IStateMetaData,
      on: {
        [TCoinTossEvents.BACK]: {
          target: TCoinTossStates.SELECT_WINNER,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.UNSET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.TO_SELECT_SIDE]: {
          target: TCoinTossStates.SELECT_SIDE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
      },
    },

    [TCoinTossStates.SELECT_SIDE]: {
      meta: {
        component: TInputTypes.TWO_ROW_GENERIC,
        componentConfiguration: {
          title: 'Team on Left',
          showLogo: false,
          showBackBtn: true,
        },
        onNext: onSideSelected,
        onBack({ send, context }) {
          send(context.inputForNextComponent.backTo);
        },
      } as IStateMetaData,
      on: {
        [TCoinTossEvents.ON_SELECTED_WINNER]: {
          target: `#${MAIN_MACHINE_ID}.${TMachineStates.INIT_KICKOFF}`,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.BACK]: {
          target: TCoinTossStates.SELECT_KICK_OR_RECEIVE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.UNSET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.BACK_TO_OFFENCE_DEFENCE]: {
          target: TCoinTossStates.SELECT_OFFENCE_DEFENCE,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.UNSET_NEXT_STATE_INPUT],
        },
        [TCoinTossEvents.TO_REGULAR_PLAY]: {
          target: `#${MAIN_MACHINE_ID}.${TMachineStates.INIT_REGULAR_PLAY}`,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
        [TMachineEvents.TO_PAT]: {
          target: `#${MAIN_MACHINE_ID}.${TMachineStates.PAT}`,
          actions: [TMachineActions.UPDATE_CONTEX, TMachineActions.SET_NEXT_STATE_INPUT],
        },
      },
    },
  },
};
